import { g as __rest, b as __assign } from '../../../../../_tslib-7a01aab4.js';
import React, { forwardRef } from 'react';

/**
 * @param {HTMLElement} children
 * @param types - "" | "from-left" | "from-right"
 * @param size - "is-full" | "is-small"
 */
var PopUpWrComponent = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'is-small' : _b, _c = _a.from, from = _c === void 0 ? 'from-left' : _c, _d = _a.types, types = _d === void 0 ? '' : _d, _e = _a.title, title = _e === void 0 ? 'pop-up title' : _e, _f = _a.className, className = _f === void 0 ? '' : _f, onClick = _a.onClick, rest = __rest(_a, ["children", "size", "from", "types", "title", "className", "onClick"]);
    return (React.createElement("div", __assign({}, rest, { className: "core-popup-wr ".concat(size, " ").concat(from, " ").concat(types, " ").concat(className) }),
        React.createElement("div", { className: 'core-popup-wr-inner', ref: ref },
            React.createElement("div", { className: 'top-core-popup-wr-inner' },
                React.createElement("div", { className: 'top-core-popup-wr-inner-row' },
                    React.createElement("p", { className: 'top-core-popup-wr-inner-row-txt' }, title),
                    onClick && React.createElement("div", { className: 'popup-close-block', onClick: onClick }))),
            React.createElement("div", { className: 'bottom-core-popup-wr-inner' },
                React.createElement("div", { className: 'scrollable-container' }, children)))));
});

export { PopUpWrComponent };
